import { render, staticRenderFns } from "./RefundResult.vue?vue&type=template&id=3c8d7af8&"
import script from "./RefundResult.vue?vue&type=script&lang=js&"
export * from "./RefundResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports